import { render, staticRenderFns } from "./CornerJointArmPreview.vue?vue&type=template&id=ecf243e0&scoped=true"
import script from "./CornerJointArmPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CornerJointArmPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CornerJointArmPreview.vue?vue&type=style&index=0&id=ecf243e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf243e0",
  null
  
)

export default component.exports